
import config from "@/config";
import http from "@/utils/request";

export default {
	gzq: {
		id: "gzq",
		url: `${config.NAIP_URL}/common/controlArea`,
		name: "管制区",
		dataName: "xzqs",
		get: async function () {
			return await http.get(this.url);
		},
	},
	jfq: {
		id: "jfq",
		name: "限制区",
		url: `${config.NAIP_URL}/common/restrictedArea`,
		dataName: "xzqs",
		get: async function () {
			return await http.get(this.url);
		},
	},
	qbq: {
		id: "qbq",
		name: "情报区",
		url: `${config.NAIP_URL}/common/flightInformationRegion`,
		dataName: "qbqVOS",
		get: async function () {
			return await http.get(this.url);
		},
	},
	hx: {
		id: "hx",
		name: "航路-逻辑航段",
		url: `${config.NAIP_URL}/common/getLogicalSegment`,
		dataName: "hanglus",
		get: async function () {
			return await http.get(this.url);
		},
	},
	ndb: {
		id: "ndb",
		name: "航路点-NDB",
		url: `${config.NAIP_URL}/common/ndbEncryption`,
		dataName: "ndbvos",
		get: async function () {
			return await http.get(this.url);
		},
	},
	vor: {
		id: "vor",
		name: "航路点-VOR",
		url: `${config.NAIP_URL}/common/vorEncryption`,
		dataName: "vorvos",
		get: async function () {
			return await http.get(this.url);
		},
	},
	hd: {
		id: "hd",
		name: "航路点-设计点",
		url: `${config.NAIP_URL}/common/dpEncryption`,
		dataName: "dpvos",
		get: async function () {
			return await http.get(this.url);
		},
	},
	hldd: {
		id: "hldd",
		name: "航路等待",
		url: `${config.NAIP_URL}/common/rhEncryption`,
		dataName: "rhvos",
		get: async function () {
			return await http.get(this.url);
		},
	},

	mhjcNo: {
		id: "mhjc",
		name: "民航机场",
		url: `${config.NAIP_URL}/common/mhjc`,
		dataName: "mhjcs",
		get: async function () {
			return await http.get(this.url);
		},
	},
	thjcNo: {
		id: "thjc",
		name: "通航机场",
		url: `${config.NAIP_URL}/common/thjc`,
		dataName: "thjc",
		get: async function () {
			return await http.get(this.url);
		},
	},

	mhjc: {
		id: "mhjc",
		name: "民航机场",
		url: `${config.NAIP_URL}/common/mhjcEncryption`,
		dataName: "mhjcs",
		get: async function () {
			return await http.get(this.url);
		},
	},
	thjc: {
		id: "thjc",
		name: "通航机场",
		url: `${config.NAIP_URL}/common/thjcEncryption1`,
		dataName: "thjc",
		get: async function (params) {
			return await http.post(this.url, params);
		},
	},
	jhjc: {
		id: "jhjc",
		name: "军航机场",
		url: `${config.MAIN_URL}/api/v1/jyAirports`,
		dataName: "jhjc",
		get: async function () {
			return await http.get(this.url, { pageNumber: 1, pageSize: 99999 });
		},
	},
	naipswitch: {

		name: "naip个性化",
		url: `${config.MAIN_URL}/api/v1/naip/switch`,
		dataName: "naipswitch",
		get: async function (params) {
			return await http.get(this.url, params);
		},
	},
	putnaipswitch: {
		url: `${config.MAIN_URL}/api/v1/naip/switch`,
		name: "naip设置监视开关状态",
		put: async function (params) {
			return await http.put(this.url + params);
		},
	},
	newVor: {
		url: `${config.NEWNAIP_URL}/api/v1/naipctr/vor`,
		name: "航路点-VOR",
		get: async function (params) {
			return await http.post(this.url, params);
		},
	},
	newNdb: {
		url: `${config.NEWNAIP_URL}/api/v1/naipctr/ndb`,
		name: "航路点-ndb",
		get: async function (params) {
			return await http.post(this.url, params);
		},
	},
	newHd: {
		url: `${config.NEWNAIP_URL}/api/v1/naipctr/designated-point`,
		name: "航路点-设计点",
		get: async function (params) {
			return await http.post(this.url, params);
		},
	},
	newHx: {
		url: `${config.NEWNAIP_URL}/api/v1/naipctr/flightSegments`,
		name: "航路-逻辑航段",
		get: async function (params) {
			return await http.post(this.url, params);
		},
	},
	newQbq: {
		url: `${config.NEWNAIP_URL}/api/v1/naipctr/qbq`,
		name: "情报区",
		get: async function (params) {
			return await http.post(this.url, params);
		},
	},
	jjgzq: {
		url: `${config.NEWNAIP_URL}/api/v1/naipctr/jjgzq`,
		name: "进近管制区",
		get: async function (params) {
			return await http.post(this.url, params);
		},
	},
	jjgzqsq: {
		url: `${config.NEWNAIP_URL}/api/v1/naipctr/jjgzqsq`,
		name: "进近管制区扇区",
		get: async function (params) {
			return await http.post(this.url, params);
		},
	},
	qygzq: {
		url: `${config.NEWNAIP_URL}/api/v1/naipctr/qygzq`,
		name: "区域管制区",
		get: async function (params) {
			return await http.post(this.url, params);
		},
	},
	qygzqsq: {
		url: `${config.NEWNAIP_URL}/api/v1/naipctr/qygzqsq`,
		name: "区域管制区扇区",
		get: async function (params) {
			return await http.post(this.url, params);
		},
	},
	// tsky: {
	// 	url: `${config.NEWNAIP_URL}/api/v1/naipctr/tsky`,
	// 	name: "特殊空域（限制区）",
	// 	get: async function (params) {
	// 		return await http.post(this.url, params);
	// 	},
	// },
	newXzq: {
		url: `${config.NEWNAIP_URL}/api/v1/naipctr/tsky`,
		name: "限制区",
		get: async function (params) {
			return await http.post(this.url, params);
		},
	},
	newWxq: {
		url: `${config.NEWNAIP_URL}/api/v1/naipctr/tsky`,
		name: "危险区",
		get: async function (params) {
			return await http.post(this.url, params);
		},
	},
	newJq: {
		url: `${config.NEWNAIP_URL}/api/v1/naipctr/tsky`,
		name: "禁区",
		get: async function (params) {
			return await http.post(this.url, params);
		},
	},
	routeHolding: {
		url: `${config.NEWNAIP_URL}/api/v1/naipctr/route-holding`,
		name: "航路等待",
		get: async function (params) {
			return await http.post(this.url, params);
		},
	},
	newMhjc: {
		url: `${config.NEWNAIP_URL}/api/v1/naipctr/ad-hp`,
		name: "民航机场",
		get: async function (params) {
			return await http.post(this.url, params);
		},
	},
	userNaipSpace: {
		url: `${config.NEWNAIP_URL}/api/v1/naipctr/areaAPoint/create`,
		name: "新增区域点",
		post: async function (params) {
			return await http.post(this.url, params);
		},
	},
	areaAPoint: {
		url: `${config.NEWNAIP_URL}/api/v1/naipctr/areaAPoint/get`,
		name: "获取区域点",
		get: async function (params) {
			return await http.get(this.url, params);
		},
	},

};
